function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "pandoradefault-a",
  x1: "85.596%",
  x2: "14.404%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#2E60FE"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#019EF1"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#pandoradefault-a)",
  d: "M3,0 C3,0 7.7975843,0 17.3927529,0 C31.7855058,0 31.6255863,13.76 27.7875189,19.2 C25.2288072,22.8266667 20.32461,24.5333333 13.074927,24.32 L13.074927,30.4 C13.074927,31.2836556 12.3589431,32 11.4757323,32 L3,32 L3,0 Z"
});

var SvgPandoraDefault = function SvgPandoraDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPandoraDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PandoraDefault.c82dbc8f.svg";
export { ForwardRef as ReactComponent };